import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import { CONTACT_FORM } from '@/helpers/constants/app';
var PlanCategory;
(function (PlanCategory) {
    PlanCategory["Free"] = "free";
    PlanCategory["Pro"] = "pro";
    PlanCategory["Enterprise"] = "enterprise";
})(PlanCategory || (PlanCategory = {}));
let ButtonGenerator = class ButtonGenerator extends Vue {
    get isFree() {
        return this.category === PlanCategory.Free;
    }
    get isPro() {
        return this.category === PlanCategory.Pro;
    }
    get isEnterprise() {
        return this.category === PlanCategory.Enterprise;
    }
    get action() {
        if (this.index > this.currentPlanIndex) {
            return 'upgrade';
        }
        return 'downgrade';
    }
    get buttonLabel() {
        return !this.accelerator ? this.label : 'Subscribed as MSME';
    }
    /**
     * Only emit onSubscribe event for basic pro tier plans such as
     * starter, bronze, silver and gold
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.50.2}
     */
    onClick() {
        const enterprisePlans = ['pro_platinum', 'pro_diamond', 'pro_mythical'];
        if (!enterprisePlans.includes(this.targetPlan)) {
            this.$emit('onSubscribe', {
                action: this.action,
                placeholder: this.placeholder,
                plan: this.targetPlan,
            });
        }
        else {
            window.open(CONTACT_FORM, '_blank');
        }
    }
    get currentPlanChecker() {
        return this.targetPlan === this.currentPlan;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ButtonGenerator.prototype, "label", void 0);
__decorate([
    Prop({ type: String, required: true })
], ButtonGenerator.prototype, "category", void 0);
__decorate([
    Prop({ type: String, default: 'Free' })
], ButtonGenerator.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: 'free_starter' })
], ButtonGenerator.prototype, "currentPlan", void 0);
__decorate([
    Prop({ type: String, default: 'free_starter' })
], ButtonGenerator.prototype, "targetPlan", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ButtonGenerator.prototype, "accelerator", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], ButtonGenerator.prototype, "index", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], ButtonGenerator.prototype, "currentPlanIndex", void 0);
ButtonGenerator = __decorate([
    Component({
        components: { ActionButton },
    })
], ButtonGenerator);
export default ButtonGenerator;
